/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'confluence-analytics-chart.default-loading-text': '正在重新整理分析資料...',
  'confluence-analytics-chart.tooltip.no-views-data': '無資料',
  'confluence-analytics-chart.tooltip.views-overall': '{count, plural, other {{count} 次檢視}}',
  'confluence-analytics-chart.tooltip.views-today-so-far': '{count, plural, other {到目前為止有 {count} 次檢視}}',
  'confuence-analytics-chart.accessible-table.caption': '頁面檢視',
  'confuence-analytics-chart.accessible-table.header.date': '日期',
  'confuence-analytics-chart.accessible-table.header.view-count': '檢視',
  'confuence-analytics-chart.accessible-table.no-view-count-data': '並未檢視',
};
